/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Convert_To_SubtitlesInputs */

const en_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert To Subtitles`)
};

const fr_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir en sous-titres`)
};

const de_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Untertitel umwandeln`)
};

const it_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti in sottotitoli`)
};

const ru_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преобразовать в субтитры`)
};

const es_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertir a subtítulos`)
};

const zh_cn2_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转换为字幕`)
};

const ja_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕に変換`)
};

const hi_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षकों में बदलें`)
};

const pt_pt2_event_group_options_convert_to_subtitles = /** @type {(inputs: Event_Group_Options_Convert_To_SubtitlesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converter em legendas`)
};

/**
* | output |
* | --- |
* | "Convert To Subtitles" |
*
* @param {Event_Group_Options_Convert_To_SubtitlesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_convert_to_subtitles = /** @type {((inputs?: Event_Group_Options_Convert_To_SubtitlesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Convert_To_SubtitlesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_convert_to_subtitles(inputs)
	if (locale === "de") return de_event_group_options_convert_to_subtitles(inputs)
	if (locale === "it") return it_event_group_options_convert_to_subtitles(inputs)
	if (locale === "ru") return ru_event_group_options_convert_to_subtitles(inputs)
	if (locale === "es") return es_event_group_options_convert_to_subtitles(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_convert_to_subtitles(inputs)
	if (locale === "ja") return ja_event_group_options_convert_to_subtitles(inputs)
	if (locale === "hi") return hi_event_group_options_convert_to_subtitles(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_convert_to_subtitles(inputs)
	return en_event_group_options_convert_to_subtitles(inputs)
});